import * as Swiper from 'swiper/dist/js/swiper.js'; 

export default class initStoriesSlider {
  constructor() {
    this.container = document.querySelector('.cp-centered-image');
    if(!this.container) return ;

    this.sliders = document.querySelectorAll('.js-stories-slider');
    this.sliders.forEach((el) => {
      this.initSlider(el)
  });
    
  }
  initSlider(slider) {
    
    if (slider.querySelectorAll('.swiper-slide').length <= 1) {
      slider.querySelector('.nav-container').classList.add('hidden');
    }

    let slidesPerViewResp;
    let space;

    if(window.innerWidth < 768){
        slidesPerViewResp = 1;
        space = 16;
    }else{
        slidesPerViewResp = 1;
        space = 24;
    }

    new Swiper(slider, {
      slidesPerView: slidesPerViewResp,
      slideClass: 'item',
      spaceBetween: space,
      navigation: {
          nextEl: `.slider-story-button-next`,
          prevEl: `.slider-story-button-prev`,
      },
      pagination: {
          el: `.swiper-pagination`,
          type: 'bullets',
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: '-current',
          clickable: true,
      },
    });
}
}